export function checkStatus() {
    let tenantId = $("#TenantId").val();
    let tenantUrl = 'https://' + $("#TenantUrl").val();
    $.ajax({
        url: `/api/validation/tenant/${tenantId}`,
        type: "GET",
        success: function (response) {
            console.log(response);
            if (response === 'Complete') {
                window.location = tenantUrl;
            }
            if (response === 'Error') {
                $("#load-container").hide();
                $("#error").show();
            }
            // if (response === 'InProgress') {
            //     ...
            // }
        },
        error: function (error) {
            console.log(`Error: ${error}`);
            clearInterval(intervalId);
            $("#load-container").hide();
            $("#error").show();
        }
    });
}

